import { render, staticRenderFns } from "./WalletHistories.vue?vue&type=template&id=e7d295f0&scoped=true&"
import script from "./WalletHistories.vue?vue&type=script&lang=ts&"
export * from "./WalletHistories.vue?vue&type=script&lang=ts&"
import style0 from "./WalletHistories.vue?vue&type=style&index=0&id=e7d295f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../namtrung_logistics/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7d295f0",
  null
  
)

export default component.exports